// app/frontend/controllers/index.js
import { Application } from "@hotwired/stimulus";

// Import controllers directly
import HelloController from "./hello_controller";
import TableFilterController from "./table_filter_controller";
import MobileMenuController from "./mobile-menu_controller";
import ModalController from "./modal_controller";
import SortableController from "./sortable_controller";
import QuoteItemController from "./quote-item_controller";
import ViewToggleController from "./view_toggle_controller";

const application = Application.start();

// Register controllers
application.register("hello", HelloController);
application.register("table-filter", TableFilterController);
application.register("mobile-menu", MobileMenuController);
application.register("modal", ModalController);
application.register("sortable", SortableController);
application.register("quote-item", QuoteItemController);
application.register("view-toggle", ViewToggleController);
